import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import ActivityBar from "../Reusable/ActivityBar/ActivityBar";
import SectionSlider from "../Reusable/SectionSlider/SectionSliderPeople";
import { sections, sectionPaths } from "../../constants/sectionDatapeople";
// import { sections, sectionPaths } from "../../constants/SectionDatapeople";
import GlobalPoliciesFileViewPopup from "../Reusable/Popup/GlobalPoliciesFileViewPopup";
import FileSection from "../Reusable/RiskSecurity/FileSelection";
import RiskManagementTool from "../GlobalPolicies/RiskManagementToolUpload";
import RiskManagementToolUpload from "../GlobalPolicies/RiskManagementToolUpload";
import GPAdminFileViewPopup from "../Reusable/Popup/GPAdminFileViewPopup";
import FileSectionCulture from "../Reusable/RiskSecurity/FileSelectionCulture";
import LearningDevelopmentUpload from "../Routine&Performance/LearningDevelopmentUpload";
import CultureUpload from "../Routine&Performance/CultureUpload";
import Culture from "../../Views/People/Culture/Culture";
import CultureSingleUpload from "../Routine&Performance/CultureSingleUpload";
import AnnualEventUpload from "../Reusable/RiskSecurity/AnnualEventUpload";

interface CultureSectionProps {
  isManager?: boolean;
  isAdmin?: boolean;

}

const CultureSection: React.FC<CultureSectionProps> = ({ isManager, isAdmin }) => {
  const management = localStorage.getItem("management") || "Default Location Name";
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedFileData, setSelectedFileData] = useState<any>(null);
  const [selectedSectionName, setSelectedSectionName] = useState<string>("");

  const handleClosePopup = () => {
    setPopupOpen(false);
  };


  const handleViewClick = (fileData: any, sectionName: string) => {
    setSelectedFileData(fileData); // Set the file data for the popup
    setSelectedSectionName(sectionName); // Set the section name for the popup
    setPopupOpen(true); // Open the popup
  };

  const handleFileUploadSuccess = () => {
    // Handle any logic after successful file upload
    console.log("File uploaded successfully");
  };

  const breadcrumbs = [
    <Link key="1" to="/">
      Home
    </Link>,
    <Link key="2" to="/operations/management">
      Evidence Upload
    </Link>,
    <Link key="3" to="/operations/management/">
      People
    </Link>,
    <Typography key="4">{management}</Typography>,
  ];

  return (
    <>
      <ActivityBar breadcrumbs={breadcrumbs} />
      <SectionSlider
        sections={sections}
        sectionPaths={sectionPaths}
        highlightSection={"Culture"}
        highlightColor="#D7A833"
        defaultColor="#666"
      />

      <Typography variant="h6" sx={{ fontWeight: '600', paddingLeft: '24px', fontSize: '16px' }}>Annual Event</Typography>
       <Typography sx={{ color: '#000', fontSize: '16px', padding:'10px 24px',pt:'5px' }}>
       Question : The 10 Principles are cascaded, visually displayed and well understood. An event is held at least once a year to activate the culture's principles for the entire center.
              </Typography>

      <Box className="titlecardrisk" sx={{ width: '100%', padding: "24px" }}>
        {/* <Culture/> */}
        <AnnualEventUpload
          key="section1"
          sectionName="Annual Event"
          payloadKey="culture"
          management={management}
          apiPath="/people/filter_culture"
          apiPathUpload="/people/culture"
          isManager={isManager}
          onFileUploadSuccess={handleFileUploadSuccess}
          onViewClick={handleViewClick} // Pass file data and section name to the popup
          fileTitle="Upload At least one center-wide event (all employees) annually that activates and reinforces the culture's principles."

        />
      </Box>

      {isManager && (
        <CultureUpload isManager={true} />

      )}

      {isAdmin && (
        <CultureUpload isAdmin={true} />
      )}



      {/* File View Popup */}
      {isPopupOpen && isManager && selectedFileData && (
        <GlobalPoliciesFileViewPopup
          onClose={handleClosePopup}
          open={true}
          name={selectedFileData.file_name}
          id={selectedFileData.id}
          functionl1={selectedFileData.function_l1}
          date={selectedFileData.created_at}
          updatedBy={selectedFileData.updated_by}
          sectionTitle={selectedSectionName} // Dynamic section title
          userDetail={true}
          apiPath={`/people/culture/${selectedFileData.id}`}
        />
      )}

      {isPopupOpen && isAdmin && selectedFileData && (
        <GPAdminFileViewPopup
          onClose={handleClosePopup}
          open={true}
          name={selectedFileData.file_name}
          id={selectedFileData.id}
          status={selectedFileData.status}
          functionl1={selectedFileData.function_l1}
          date={selectedFileData.created_at}
          updatedBy={selectedFileData.updated_by}
          sectionTitle={selectedSectionName} // Dynamic section title
          apiPath={`/people/culture/${selectedFileData.id}`} // Pass the API path for file details
          statusApiPath="/people/culture_status" // Pass the API path for status updates
          reason_to_approve={selectedFileData.reason_to_approve}
          reason_to_revert={selectedFileData.reason_to_revert}
        />
      )}
    </>
  );
};

export default CultureSection;